<template>
    <h2>No hemos encontrado lo que buscaba</h2>
    <div>404</div>
</template>

<style scoped>
h2{
    font-size: 38px;
    text-align: center;
    margin: 30px 0;
}

div{
    font-size: 200px;
    text-align: center;
    margin-top: 30px;
    font-weight: 900;
}
</style>